








import { Component, Vue } from "vue-property-decorator"
import store from "@/store"

@Component
export default class BusinessActivate extends Vue {
  showContent = true

  async beforeRouteEnter(to, from, next) {
    console.debug("Page component BusinessActivate.vue beforeRouteEnter")

    const { code: code } = to.query

    const loginRouteName =
      process.env.VUE_APP_WP_VERSION === "v2" ? "v2-login" : "business-login"

    if (code) {
      await store
        .dispatch("Auth/businessActivate", {
          params: {
            code,
          },
        })
        .then((response) => {
          console.debug(
            "User activation status: ",
            response.data?.data?.is_activated
          )
          if (response.data.data.is_activated) {
            console.debug(
              "BusinessActivate.vue beforeRouteEnter redirects to login"
            )
            return next({
              name: loginRouteName,
              query: { activated: 1 },
            })
          }
        })
        .catch(() => {
          console.debug("BusinessActivate errors")
          return next()
        })
    }

    console.debug("Page component BusinessActivate.vue beforeRouteEnter END")
    return next()
  }
}
